<template>
    <div>
        <Head :title="title" />
<!--        <jet-banner />-->

        <div class="bg-gray-100 dark:bg-zinc-900">
            <TransitionRoot as="template" :show="sidebarOpen">
                <Dialog as="div" class="relative z-50 lg:hidden" @close="sidebarOpen = false">
                    <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
                        <div class="fixed inset-0 bg-gray-900/80" />
                    </TransitionChild>

                    <div class="fixed inset-0 flex">
                        <TransitionChild as="template" enter="transition ease-in-out duration-300 transform" enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0" leave-to="-translate-x-full">
                            <DialogPanel class="relative mr-16 flex w-full max-w-xs flex-1">
                                <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
                                    <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
                                        <button type="button" class="-m-2.5 p-2.5" @click="sidebarOpen = false">
                                            <span class="sr-only">Close sidebar</span>
                                            <font-awesome-icon :icon="faClose" size="2x" class="text-white" aria-hidden="true" />
                                        </button>
                                    </div>
                                </TransitionChild>
                                <!-- Sidebar component, swap this element with another sidebar if you like -->
                                <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-rent-risk-blue-400 px-6 pb-4">
                                    <div class="flex h-16 mt-5 shrink-0 items-center">
                                        <Link
                                            :href="route('properties.index')"
                                        >
                                            <img :src="logo" alt="RentRisk Logo" class="w-full p-2" />
                                        </Link>
                                    </div>
                                    <nav class="flex flex-1 flex-col">
                                        <ul role="list" class="flex flex-1 flex-col gap-y-7">
                                            <li>
                                                <ul role="list" class="-mx-2 space-y-1">
                                                    <!-- MOBILE MENU -->
                                                    <template v-for="item in filteredMenu" :key="item.id">
                                                        <li
                                                            class="mb-2"
                                                            :class="[{ 'bg-gray-800 rounded-md': isDropdownOpen(item.id) }]"
                                                            v-if="item.role === 'everyone' || (item.role === 'agent' && $page.props.auth.user.role === 'agent')"
                                                        >
                                                            <button
                                                                v-if="item.dropdown"
                                                                type="button"
                                                                class="text-white relative group flex items-center gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold w-full hover:bg-gray-800"
                                                                :class="{ 'hover:rounded-t-md': isDropdownOpen(item.id) }"
                                                                @click="toggleDropdown(item.id)"
                                                            >
                                                                <font-awesome-icon :icon="item.icon" class="text-white shrink-0 h-5 w-5" />
                                                                {{ item.name }}
                                                                <font-awesome-icon
                                                                    :icon="faChevronDown"
                                                                    :class="{ 'rotate-180': isDropdownOpen(item.id) }"
                                                                    class="transition-transform duration-300 ml-auto"
                                                                />
                                                            </button>

                                                            <!-- SECOND LEVEL -->
                                                            <ul
                                                                v-if="isDropdownOpen(item.id)"
                                                                class="bg-gray-800 rounded-md text-white"
                                                            >
                                                                <template v-for="(dropdown_item, index) in item.children" :key="dropdown_item.id">
                                                                    <li v-if="dropdown_item.dropdown">
                                                                        <button
                                                                            type="button"
                                                                            class="flex items-center gap-x-3 py-2 pl-6 w-full text-sm font-semibold text-left hover:bg-gray-600"
                                                                            :class="[index === (item.children.length-1) && !isSubDropdownOpen(item.id, dropdown_item.id) ? 'rounded-b-md' : '']"
                                                                            @click="toggleSubDropdown(item.id, dropdown_item.id)"
                                                                        >
                                                                            <font-awesome-icon :icon="dropdown_item.icon" class="text-white shrink-0 h-5 w-5" />
                                                                            {{ dropdown_item.name }}
                                                                            <font-awesome-icon
                                                                            :icon="faChevronDown"
                                                                            :class="{ 'rotate-180': isSubDropdownOpen(item.id, dropdown_item.id) }"
                                                                            class="transition-transform duration-300 ml-auto mr-2"
                                                                            />
                                                                        </button>

                                                                        <!-- THIRD LEVEL -->
                                                                        <ul
                                                                            v-if="isSubDropdownOpen(item.id, dropdown_item.id)"
                                                                            class="bg-gray-800 text-white rounded-b-md"
                                                                        >
                                                                            <template v-for="(child_item, index1) in dropdown_item.children" :key="child_item.id">
                                                                            <li>
                                                                                <Link
                                                                                    :href="route(child_item.href)"
                                                                                    class="flex items-center gap-x-3 py-2 pl-10 text-sm font-semibold w-full"
                                                                                    :class="[
                                                                                        child_item.active ? 'bg-gray-600 text-white' : 'text-white hover:bg-gray-600',
                                                                                        index1 === (dropdown_item.children.length - 1) ? 'rounded-b-md' : ''
                                                                                    ]"
                                                                                >
                                                                                    <font-awesome-icon :icon="child_item.icon" class="shrink-0 h-5 w-5" />
                                                                                    {{ child_item.name }}
                                                                                </Link>
                                                                            </li>
                                                                            </template>
                                                                        </ul>
                                                                    </li>

                                                                    <!-- SECOND LEVEL LINK (no children) -->
                                                                    <li v-else>
                                                                        <Link
                                                                            :href="route(dropdown_item.href)"
                                                                            class="flex items-center gap-x-3 py-2 pl-6 text-sm font-semibold w-full"
                                                                            :class="[
                                                                            dropdown_item.active ? 'bg-gray-600 text-white' : 'text-white hover:bg-gray-600',
                                                                            index === (item.children.length - 1) ? 'rounded-b-md' : ''
                                                                            ]"
                                                                        >
                                                                            <font-awesome-icon :icon="dropdown_item.icon" class="shrink-0 h-5 w-5" />
                                                                            {{ dropdown_item.name }}
                                                                        </Link>
                                                                    </li>
                                                                </template>
                                                            </ul>

                                                            <!-- FIRST LEVEL LINK (no children) -->
                                                            <Link
                                                                v-if="item.dropdown === undefined || !item.dropdown"
                                                                :href="item.params ? route(item.href, item.params) : route(item.href)"
                                                                class="flex items-center gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold w-full"
                                                                :class="[
                                                                    item.active ? 'bg-gray-800 text-white' : 'text-white hover:bg-gray-800'
                                                                ]"
                                                            >
                                                                <font-awesome-icon :icon="item.icon" class="shrink-0 h-5 w-5" />
                                                                <span class="flex justify-between items-center w-full">
                                                                    {{ item.name }}
                                                                    <span
                                                                        v-if="item.badge"
                                                                        class="menu-badge"
                                                                    >
                                                                        {{ item.badge }}
                                                                    </span>
                                                                </span>
                                                            </Link>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </li>
                                            <li class="mt-auto">
                                                <OnboardingHubCard />
                                                <LegalAdviceCard />
                                                <Link
                                                    v-if="$page.props.auth?.user?.is_admin"
                                                    :href="route('bridge.index')"
                                                    class="group flex items-center gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                                                    :class="[bridgeActive ? 'bg-gray-800 text-white' : 'text-white hover:bg-gray-800']"
                                                >
                                                    <font-awesome-icon :icon="faAnchor" size="lg" class="shrink-0 text-white" aria-hidden="true" />
                                                    Bridge
                                                </Link>
                                                <Link :href="route('logout')" method="post" as="button" class="text-white hover:text-gray-400 hover:bg-gray-800 group flex gap-x-3 rounded-md p-2 text-sm items-center leading-6 font-semibold">
                                                    <font-awesome-icon :icon="faSignOut" size="lg" class="shrink-0 text-white group-hover:text-gray-800" aria-hidden="true" />
                                                    Sign Out
                                                </Link>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </Dialog>
            </TransitionRoot>

            <!-- Static sidebar for desktop -->
            <div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col transition-all duration-300 ease-in-out" :class="sidebarCollapsed ? 'lg:w-16 overflow-visible' : 'lg:w-72'">
                <!-- Sidebar component, swap this element with another sidebar if you like -->
                <div class="flex grow flex-col gap-y-5 bg-rent-risk-blue-400 pb-4 transition-all duration-300 ease-in-out" :class="[sidebarCollapsed ? 'px-2 overflow-y-auto overflow-x-visible' : 'px-6 overflow-y-auto overflow-x-hidden']">
                    <div class="flex h-16 mt-5 shrink-0 items-center justify-between">
                        <!-- Logo -->
                        <div class="flex-1" :class="sidebarCollapsed ? 'hidden' : ''">
                            <Link
                                :href="route('properties.index')"
                            >
                                <img :src="logo" alt="RentRisk Logo" class="w-full p-2" />
                            </Link>
                        </div>
                        <!-- Collapsed Logo/Icon -->
                        <div v-if="sidebarCollapsed" class="flex justify-center w-full">
                            <Link :href="route('properties.index')">
                                <div class="w-8 h-8 bg-white rounded-md flex items-center justify-center">
                                    <span class="text-rent-risk-blue-400 font-bold text-lg">R</span>
                                </div>
                            </Link>
                        </div>
                        <!-- Toggle Button -->
                        <button 
                            @click="sidebarCollapsed = !sidebarCollapsed"
                            class="p-1 rounded-md text-white hover:bg-gray-800 transition-colors duration-200"
                            :class="sidebarCollapsed ? 'ml-0' : 'ml-2'"
                            title="Toggle Sidebar"
                        >
                            <font-awesome-icon 
                                :icon="sidebarCollapsed ? faChevronRight : faChevronLeft" 
                                class="h-4 w-4" 
                            />
                        </button>
                    </div>
                    <nav class="flex flex-1 flex-col">
                        <ul role="list" class="flex flex-1 flex-col gap-y-7">
                            <li>
                                <ul role="list" :class="sidebarCollapsed ? 'mx-0 space-y-2' : '-mx-2'">
                                    <!-- DESKTOP MENU -->
                                    <template v-for="item in filteredMenu" :key="item.id">
                                        <!-- Collapsed Sidebar View -->
                                        <li v-if="sidebarCollapsed && (item.role === 'everyone' || (item.role === 'agent' && $page.props.auth.user.role === 'agent'))" 
                                            class="relative">
                                            <!-- Collapsed Menu Item (Icon only) -->
                                            <div class="relative"
                                                 @mouseenter="showFlyout($event, item.id)"
                                                 @mouseleave="hideFlyout($event, item.id)">
                                                <button
                                                    v-if="item.dropdown"
                                                    type="button"
                                                    class="text-white relative flex items-center justify-center rounded-md p-2 w-full hover:bg-gray-800 transition-colors duration-200"
                                                    :class="{ 'bg-gray-800': item.active }"
                                                    :title="item.name"
                                                >
                                                    <font-awesome-icon :icon="item.icon" class="text-white h-5 w-5" />
                                                </button>
                                                <Link
                                                    v-else
                                                    :href="item.params ? route(item.href, item.params) : route(item.href)"
                                                    class="text-white flex items-center justify-center rounded-md p-2 w-full hover:bg-gray-800 transition-colors duration-200"
                                                    :class="{ 'bg-gray-800': item.active }"
                                                    :title="item.name"
                                                >
                                                    <font-awesome-icon :icon="item.icon" class="text-white h-5 w-5" />
                                                </Link>
                                            </div>
                                        </li>
                                        
                                        <!-- Expanded Sidebar View -->
                                        <li v-else-if="!sidebarCollapsed && (item.role === 'everyone' || (item.role === 'agent' && $page.props.auth.user.role === 'agent'))"
                                            class="mb-2"
                                            :class="[{ 'bg-gray-800 rounded-md': isDropdownOpen(item.id) }]"
                                        >
                                            <button
                                                v-if="item.dropdown"
                                                type="button"
                                                class="text-white relative group flex items-center gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold w-full hover:bg-gray-800"
                                                :class="{ 'hover:rounded-t-md': isDropdownOpen(item.id) }"
                                                @click="toggleDropdown(item.id)"
                                            >
                                                <font-awesome-icon :icon="item.icon" class="text-white shrink-0 h-5 w-5" />
                                                {{ item.name }}
                                                <font-awesome-icon
                                                    :icon="faChevronDown"
                                                    :class="{ 'rotate-180': isDropdownOpen(item.id) }"
                                                    class="transition-transform duration-300 ml-auto"
                                                />
                                            </button>

                                            <!-- SECOND LEVEL -->
                                            <ul
                                                v-if="isDropdownOpen(item.id)"
                                                class="bg-gray-800 rounded-md text-white"
                                            >
                                                <template v-for="(dropdown_item, index) in item.children" :key="dropdown_item.id">
                                                    <li v-if="dropdown_item.dropdown">
                                                        <button
                                                            type="button"
                                                            class="flex items-center gap-x-3 py-2 pl-6 w-full text-sm font-semibold text-left hover:bg-gray-600"
                                                            :class="[index === (item.children.length-1) && !isSubDropdownOpen(item.id, dropdown_item.id) ? 'rounded-b-md' : '']"
                                                            @click="toggleSubDropdown(item.id, dropdown_item.id)"
                                                        >
                                                            <font-awesome-icon :icon="dropdown_item.icon" class="text-white shrink-0 h-5 w-5" />
                                                            {{ dropdown_item.name }}
                                                            <font-awesome-icon
                                                            :icon="faChevronDown"
                                                            :class="{ 'rotate-180': isSubDropdownOpen(item.id, dropdown_item.id) }"
                                                            class="transition-transform duration-300 ml-auto mr-2"
                                                            />
                                                        </button>

                                                        <!-- THIRD LEVEL -->
                                                        <ul
                                                            v-if="isSubDropdownOpen(item.id, dropdown_item.id)"
                                                            class="bg-gray-800 text-white rounded-b-md"
                                                        >
                                                            <template v-for="(child_item, index1) in dropdown_item.children" :key="child_item.id">
                                                            <li>
                                                                <Link
                                                                    :href="route(child_item.href)"
                                                                    class="flex items-center gap-x-3 py-2 pl-10 text-sm font-semibold w-full"
                                                                    :class="[
                                                                        child_item.active ? 'bg-gray-600 text-white' : 'text-white hover:bg-gray-600',
                                                                        index1 === (dropdown_item.children.length - 1) ? 'rounded-b-md' : ''
                                                                    ]"
                                                                >
                                                                    <font-awesome-icon :icon="child_item.icon" class="shrink-0 h-5 w-5" />
                                                                    {{ child_item.name }}
                                                                </Link>
                                                            </li>
                                                            </template>
                                                        </ul>
                                                    </li>

                                                    <!-- SECOND LEVEL LINK (no children) -->
                                                    <li v-else>
                                                        <Link
                                                            :href="route(dropdown_item.href)"
                                                            class="flex items-center gap-x-3 py-2 pl-6 text-sm font-semibold w-full"
                                                            :class="[
                                                            dropdown_item.active ? 'bg-gray-600 text-white' : 'text-white hover:bg-gray-600',
                                                            index === (item.children.length - 1) ? 'rounded-b-md' : ''
                                                            ]"
                                                        >
                                                            <font-awesome-icon :icon="dropdown_item.icon" class="shrink-0 h-5 w-5" />
                                                            {{ dropdown_item.name }}
                                                        </Link>
                                                    </li>
                                                </template>
                                            </ul>

                                            <!-- FIRST LEVEL LINK (no children) -->
                                            <Link
                                                v-if="item.dropdown === undefined || !item.dropdown"
                                                :href="item.params ? route(item.href, item.params) : route(item.href)"
                                                class="flex items-center gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold w-full"
                                                :class="[
                                                    item.active ? 'bg-gray-800 text-white' : 'text-white hover:bg-gray-800'
                                                ]"
                                            >
                                                <font-awesome-icon :icon="item.icon" class="shrink-0 h-5 w-5" />
                                                <span class="flex justify-between items-center w-full">
                                                    {{ item.name }}
                                                    <span
                                                        v-if="item.badge"
                                                        class="menu-badge"
                                                    >
                                                        {{ item.badge }}
                                                    </span>
                                                </span>
                                            </Link>
                                        </li>
                                    </template>
                                </ul>
                            </li>
                            <li class="mt-auto">
                                <OnboardingHubCard :collapsed="sidebarCollapsed" />
                                <LegalAdviceCard :collapsed="sidebarCollapsed" />
                                <Link
                                    v-if="$page.props.auth?.user?.is_admin"
                                    :href="route('bridge.index')"
                                    class="w-full text-left group flex items-center rounded-md p-2 text-sm leading-6 font-semibold"
                                    :class="[
                                        sidebarCollapsed ? 'justify-center gap-x-0' : 'gap-x-3',
                                        bridgeActive ? 'bg-gray-800 text-white' : 'text-white hover:text-white hover:bg-gray-800'
                                    ]"
                                    :title="sidebarCollapsed ? 'Bridge' : ''"
                                >
                                    <font-awesome-icon :icon="faAnchor" size="lg" class="shrink-0 text-white" aria-hidden="true" />
                                    <span v-if="!sidebarCollapsed">Bridge</span>
                                </Link>
                                <Link :href="route('logout')" method="post" as="button"
                                      class="w-full text-left text-white hover:text-white hover:bg-gray-800 group flex items-center rounded-md p-2 text-sm leading-6 font-semibold"
                                      :class="sidebarCollapsed ? 'justify-center gap-x-0' : 'gap-x-3'"
                                      :title="sidebarCollapsed ? 'Sign Out' : ''"
                                >
                                    <font-awesome-icon :icon="faSignOut" size="lg" class="shrink-0 text-white group-hover:text-white" aria-hidden="true" />
                                    <span v-if="!sidebarCollapsed">Sign Out</span>
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div id="body" class="transition-all duration-300 ease-in-out min-h-[calc(100vh-70px)]" :class="sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-72'">
                <div class="sticky top-0 z-50 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
                    <button type="button" class="-m-2.5 p-2.5 text-gray-700 lg:hidden" @click="sidebarOpen = true">
                        <span class="sr-only">Open sidebar</span>
                        <font-awesome-icon :icon="faBars" aria-hidden="true" />
                    </button>

                    <!-- Separator -->
                    <div class="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true" />

                    <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
                        <!--                        <div class="relative flex flex-1"></div>-->
                        <div class=" relative flex flex-1 items-center">
                            <div v-if="$page.props.env !== 'PRODUCTION'" :class="[
                        ($page.props.env === 'LOCAL') ? 'bg-green-200 text-green-800' : (($page.props.env === 'DEMO') ? 'bg-yellow-200 text-yellow-800' : 'bg-red-200 text-red-800'),' text-sm font-semibold text-center px-2 py-1 rounded-md'
                      ]">
                                {{ $page.props.env }}
                            </div>
                            <template v-if="$page.props.env === 'LOCAL'">
                                <div class="bg-blue-50 text-blue-700 rounded-md ml-3 px-2 py-1 text-xs font-semibold">
                                  <div class="max-w-sm:flex sm:hidden">
                                  SM
                                  </div>

                                  <div class="hidden sm:flex md:hidden">
                                  MD
                                  </div>

                                  <div class="hidden md:flex lg:hidden">
                                  LG
                                  </div>

                                  <div class="hidden lg:flex xl:hidden">
                                  XL
                                  </div>

                                  <div class="hidden xl:flex 2xl:hidden">
                                  2XL
                                  </div>

                                  <div class="hidden 2xl:flex">
                                  Beyond 2XL
                                  </div>
                                </div>
                            </template>
                        </div>
                        <form class="hidden relative flex flex-1" action="#" method="GET">
                            <label for="search-field" class="sr-only">Search</label>
                            <font-awesome-icon :icon="faMagnifyingGlass" :size="'sm'" :class="'pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-400'" aria-hidden="true" />
                            <input id="search-field" class="block h-full w-full border-0 py-0 pl-8 pr-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm" placeholder="Search..." type="search" name="search" />
                        </form>
                        <div class="flex items-center gap-x-4 lg:gap-x-6">
                            <template v-if="$page.props.auth.user.tenant_count > 1">
                                <div class="bg-blue-50 text-blue-700 rounded-md ml-3 px-4 py-2 font-bold">
                                    {{ $page.props.tenant.name }}
                                </div>
                            </template>
                            <button type="button" class="hidden -m-2.5 p-2.5 text-gray-400 hover:text-gray-500">
                                <span class="sr-only">View notifications</span>
                                <font-awesome-icon :icon="faBell" size="lg" aria-hidden="true" />
                            </button>

                            <!-- 86bcd9hg3 (decision 24): the account-wide Pro call to action.
                                 86bc9e403: a Basic landlord's upgrade opens the combined checkout
                                 in place; switch / fix-card still link out (a full page load so the
                                 Billing page sees #switch-plan when it mounts). -->
                            <button
                                v-if="proNav && proNav.action === 'upgrade'"
                                type="button"
                                class="inline-flex items-center rounded-full bg-gold-500 px-3 py-1 text-xs font-bold text-[#7d6310] hover:bg-gold-700"
                                data-test="pro-upgrade-nav"
                                @click="openProUpgrade"
                            >
                                {{ proNav.label }}
                            </button>
                            <a
                                v-else-if="proNav"
                                :href="proNav.href"
                                class="inline-flex items-center rounded-full bg-gold-500 px-3 py-1 text-xs font-bold text-[#7d6310] hover:bg-gold-700"
                                data-test="pro-upgrade-nav"
                            >
                                {{ proNav.label }}
                            </a>

                            <!-- Separator lg:block -->
                            <div class="hidden lg:h-6 lg:w-px lg:bg-gray-900/10" aria-hidden="true" />

                            <!-- Profile dropdown -->
                            <Menu as="div" class="relative">
                                <MenuButton class="-m-1.5 flex items-center p-1.5">
                                    <span class="sr-only">Open user menu</span>
                                    <span class="flex items-center">
                                        <span class="mr-4 text-sm font-semibold leading-6 text-gray-900 flex flex-col items-start" aria-hidden="true">
                                            {{ $page.props.auth.user.name }}
                                            <Link
                                                v-if="experianPrompt"
                                                :href="route('experian-verification.create')"
                                                class="text-xs font-normal text-orange-600 hover:text-orange-500"
                                                data-test="experian-verification-link"
                                            >
                                                {{ experianPrompt }} <span aria-hidden="true">&rarr;</span>
                                            </Link>
                                            <Link v-else-if="progress < 100" :href="route('profile.show')" class="text-sm text-gray-500 font-normal">
                                                Setup Profile Here
                                            </Link>
                                        </span>
                                        <span>
                                            <div class="flex items-center space-x-4">
                                                <!-- Avatar Progress Bar with click to test different values -->
                                                <AvatarProgress
                                                    :progress="progress"
                                                    :avatar="$page.props.auth.user.profile_photo_url || null"
                                                    :name="$page.props.auth.user.name"
                                                    :show-percentage="false"
                                                    :animate="true"
                                                    :animation-duration="1500"
                                                    :initial-delay="800"
                                                    size="sm"
                                                />
                                            </div>
                                        </span>
                                        <font-awesome-icon :icon="faChevronDown" size="lg" class="ml-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </span>
                                </MenuButton>
                                <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                                    <MenuItems class="absolute right-0 z-10 mt-2.5 min-w-[12rem] origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                                        <MenuItem>
                                            <Link :href="route('profile.show')" :class="[(route().current('profile.show')) ? 'bg-gray-100' : '', 'block px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-100']"><font-awesome-icon :icon="faUserAlt" /> Profile</Link>
                                        </MenuItem>
                                        <MenuItem v-if="page.props.user.role === 'agent'">
                                            <Link :href="route('screening-rules.edit')" :class="[(route().current('screening-rules.edit')) ? 'bg-gray-100' : '', 'block px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-100']"><font-awesome-icon :icon="faChartPie" /> Settings</Link>
                                        </MenuItem>
                                        <MenuItem v-if="page.props.auth.user?.role === 'agent'">
                                            <Link :href="route('collaborators.index')" :class="[(route().current('collaborators.index')) ? 'bg-gray-100' : '', 'block whitespace-nowrap px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-100']"><font-awesome-icon :icon="faEye" /> Access</Link>
                                        </MenuItem>
                                        <MenuItem v-if="page.props.auth.user?.role === 'agent' && page.props.auth.user?.has_owned_properties">
                                            <Link :href="route('landlord.documents.index')" :class="[(route().current('landlord.documents.index')) ? 'bg-gray-100' : '', 'block whitespace-nowrap px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-100']"><font-awesome-icon :icon="faFileLines" /> Documents</Link>
                                        </MenuItem>
                                        <MenuItem v-if="page.props.user.role === 'agent'">
                                            <Link :href="route('partners.index')" :class="[(route().current('partners.*') || route().current('partner-program.*')) ? 'bg-gray-100' : '', 'block whitespace-nowrap px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-100']"><font-awesome-icon :icon="faHandshake" /> Passive Income</Link>
                                        </MenuItem>
                                        <MenuItem v-if="page.props.user.role === 'agent'">
                                            <a
                                                href="https://www.facebook.com/groups/militaryrentals"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                class="block px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-100"
                                            ><font-awesome-icon :icon="faFacebook" /> Military Rentals</a>
                                        </MenuItem>
                                        <!-- 86bc70q8c: Billing sits at the bottom, just above Sign Out. -->
                                        <MenuItem v-if="page.props.user.role === 'agent'">
                                            <Link :href="route('payment-methods.index')" :class="[(route().current('payment-methods.index')) ? 'bg-gray-100' : '', 'block px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-100']"><font-awesome-icon :icon="faCreditCard" /> Billing</Link>
                                        </MenuItem>
                                        <MenuItem>
                                            <Link :href="route('logout')" method="post" as="button" class="w-full text-left px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-100"><font-awesome-icon :icon="faRightFromBracket" /> Sign Out</Link>
                                        </MenuItem>
                                    </MenuItems>
                                </transition>
                            </Menu>
                        </div>
                    </div>
                </div>

                <!-- Impersonation Banner -->
                <div v-if="$page.props.impersonating" class="bg-yellow-500 border-b-4 border-yellow-700">
                    <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
                        <div class="flex items-center justify-between flex-wrap">
                            <div class="w-0 flex-1 flex items-center">
                                <span class="flex p-2 rounded-lg bg-yellow-700">
                                    <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </span>
                                <p class="ml-3 font-medium text-white">
                                    <span class="md:hidden">
                                        Impersonating {{ $page.props.auth.user.name }}
                                    </span>
                                    <span class="hidden md:inline">
                                        You are currently impersonating {{ $page.props.auth.user.name }} ({{ $page.props.auth.user.email }})
                                    </span>
                                </p>
                            </div>
                            <div class="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
                                <button
                                    @click="stopImpersonation"
                                    :disabled="stoppingImpersonation"
                                    class="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-yellow-600 bg-white hover:bg-yellow-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <svg v-if="stoppingImpersonation" class="animate-spin -ml-1 mr-2 h-4 w-4 text-yellow-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    {{ stoppingImpersonation ? 'Stopping...' : 'Stop Impersonating' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <pmc-register-banner v-if="!$page.props.auth?.user?.is_admin" class="mx-4 mt-4 sm:mx-6 lg:mx-8" />
                <main class="py-10">
                    <!-- Page Heading -->
                    <header id="page-heading" class="ml-0 sm:ml-2 lg:ml-0" v-if="$slots.header">
                        <slot name="header"></slot>
                    </header>
                    <div class="sm:mt-5 px-4 sm:px-6 lg:px-8">
                        <slot></slot>
                    </div>
                </main>
            </div>


            <footer class="bg-white static bottom-0 w-full transition-all duration-300 ease-in-out" :class="sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-72'">
                <div class="px-4 py-3 sm:px-6 flex flex-col md:flex-row justify-between items-center">
                    <div class="grid grid-cols-3 gap-4 items-center justify-items-center">
                        <img :src="rentrisk_color_logo" class="h-8" alt="RentRisk LLC" />
                        <img class="h-11" alt="Data Provided by Experian Logo" :src="experian_logo" />
                        <img :src="plaid_logo" class="h-7">
                    </div>
                    <div>
                        <p class="text-sm text-gray-400">
                            &copy; {{ currentYear }} RentRisk, LLC. All rights reserved.
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    </div>
    <simple-notification />
    <maintenance-notice-modal />
    <tos-reacceptance-modal />
    <show-blog-popup v-if="is_show_blog_popup"  @closeAlert="is_show_blog_popup = false"></show-blog-popup>

    <!-- 86bc9e403: the top-bar "Upgrade to Pro" pill opens the combined checkout in place.
         The SetupIntent is fetched on demand (openProUpgrade) so a page load never pays for
         a pop-up nobody opens. Only mounted for a Basic landlord whose pill offers 'upgrade'. -->
    <template v-if="proNav && proNav.action === 'upgrade'">
        <RiskGuardProUpsellModal
            :show="showProUpgradeModal"
            :processing="isProUpgrading"
            :stripe-data="proStripeData"
            :user-payment-method="proUserPaymentMethod"
            :subscription="proSubscription"
            :show-features="true"
            :notice="proTierChangedNotice"
            @subscribe="onProSubscribeStart"
            @card-saved="onProCardSaved"
            @dismiss="closeProUpgradeModal"
        />
        <SubscriptionProtection
            ref="proSubscription"
            subscription-type="protect"
            plan-slug="protect-pro-tiered"
            billing-cycle="annual"
            :terms-accepted="proTermsAccepted"
            :always-send-terms="true"
            :has-payment-method="Boolean(proUserPaymentMethod)"
            :user-payment-method="proUserPaymentMethod"
            :stripe-data="proStripeData ?? []"
            @success="onProSubscribeSuccess"
            @error="onProSubscribeError"
            @cancel="isProUpgrading = false"
            @tier-changed="onProTierChanged"
        />
    </template>
<!--    <slide-over />-->

    <!-- Body-level Flyout Menus for Collapsed Sidebar -->
    <template v-if="sidebarCollapsed">
        <div v-for="item in filteredMenu" :key="`flyout-${item.id}`">
            <div v-if="item.dropdown" 
                 :data-flyout-id="item.id"
                 class="invisible opacity-0 fixed w-64 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-[9999] transition-all duration-200"
                 @mouseenter="keepFlyoutOpen($event, item.id)"
                 @mouseleave="hideFlyout($event, item.id)">
                <div class="p-1">
                    <!-- Flyout Header -->
                    <div class="px-3 py-2 border-b border-gray-200">
                        <h3 class="text-sm font-semibold text-gray-900">{{ item.name }}</h3>
                    </div>
                    <!-- Flyout Items -->
                    <div class="py-1">
                        <template v-for="(dropdown_item, index) in item.children" :key="dropdown_item.id">
                            <!-- Flyout Sub-dropdown -->
                            <div v-if="dropdown_item.dropdown" class="relative"
                                 @mouseenter="showNestedFlyout($event, item.id, dropdown_item.id)"
                                 @mouseleave="hideNestedFlyout($event, item.id, dropdown_item.id)">
                                <button
                                    type="button"
                                    class="group/btn flex items-center w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 rounded-md"
                                >
                                    <font-awesome-icon :icon="dropdown_item.icon" class="mr-3 h-4 w-4 text-gray-500" />
                                    {{ dropdown_item.name }}
                                    <font-awesome-icon :icon="faChevronRight" class="ml-auto h-3 w-3 text-gray-400" />
                                </button>
                                
                                <!-- Nested Flyout Menu -->
                                <div :data-nested-flyout-id="`${item.id}-${dropdown_item.id}`"
                                     class="invisible opacity-0 absolute left-full top-0 ml-1 w-64 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-[10000] transition-all duration-200"
                                     @mouseenter="keepNestedFlyoutOpen($event, item.id, dropdown_item.id)"
                                     @mouseleave="hideNestedFlyout($event, item.id, dropdown_item.id)">
                                    <div class="py-1">
                                        <template v-for="nested_item in dropdown_item.children" :key="nested_item.id">
                                            <Link :href="route(nested_item.href)"
                                                  class="flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 rounded-md"
                                                  :class="{ 'bg-blue-50 text-blue-700': nested_item.active }">
                                                <font-awesome-icon :icon="nested_item.icon" class="mr-3 h-4 w-4 text-gray-500" />
                                                {{ nested_item.name }}
                                            </Link>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Regular Flyout Item -->
                            <Link v-else :href="route(dropdown_item.href)"
                                  class="flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 rounded-md transition duration-150 ease-in-out"
                                  :class="[{ 'bg-blue-50 text-blue-700': dropdown_item.active }, childClass(item.children, index)]">
                                <font-awesome-icon :icon="dropdown_item.icon" class="mr-3 h-4 w-4 text-gray-500" />
                                {{ dropdown_item.name }}
                            </Link>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </template>
</template> 

<script setup>
    import { ref, computed, onMounted, reactive, watch } from 'vue'
    import { usePage } from '@inertiajs/vue3'
    import FlashMessages from '@/Shared/FlashMessages.vue'
    import Notification from '@/Shared/Notification.vue'
    import PmcRegisterBanner from '@/Pages/V2/Properties/Components/PmcRegisterBanner.vue'
    import { Head, Link } from '@inertiajs/vue3';
    import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
    import moment from 'moment';
    import { router } from '@inertiajs/vue3'
    import logo from '../../images/rentrisk-logo.png';
    import experian_logo from '../../images/Experian-BM-Data-Provided-By.svg';
    import rentrisk_color_logo from '../../images/rentrisk-logo-colored.png';
    import plaid_logo from '../../images/plaid_logo.svg';
    const sidebarOpen = ref(false)
    const sidebarCollapsed = ref(localStorage.getItem('sidebarCollapsed') === 'true')
    
    // Watch for sidebar collapse state changes and persist to localStorage
    watch(sidebarCollapsed, (newValue) => {
        localStorage.setItem('sidebarCollapsed', newValue.toString())
    })
    /* import font awesome icon component */
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    /* import specific icons */
    import {
        faHouseBuilding, 
        faHandshake,
        faBars,
        faBell,
        faMagnifyingGlass,
        faClose,
        faChevronDown,
        faSignOut,
        faChevronLeft,
        faChevronRight,
        faChartPie,
        faUserAlt,
        faCreditCard,
        faRightFromBracket,
        faHouseWater,
        faHouseLock,
        faFlag,
        faSquareDollar,
        faScreenUsers,
        faCommentsDollar,
        faQuestionCircle,
        faWrench,
        faShieldExclamation,
        faBlog,
        faEye,
        faClipboardList,
        faFileLines,
        faAnchor,
    } from '@fortawesome/pro-light-svg-icons'
    import { faFacebook } from '@fortawesome/free-brands-svg-icons'

    import SimpleNotification from "@/Shared/SimpleNotification.vue";
    import MaintenanceNoticeModal from '@/Shared/MaintenanceNoticeModal.vue';
    import TosReacceptanceModal from '@/Shared/TosReacceptanceModal.vue';
    import ShowBlogPopup from '@/Shared/ShowBlogPopup.vue';
    import AvatarProgress from '@/Shared/AvatarProgress.vue';
    import LegalAdviceCard from '@/Components/LegalAdviceCard.vue';
    import OnboardingHubCard from '@/Components/OnboardingHubCard.vue';
    import { isHomeNavActive } from '@/Layouts/homeNavActive';
    import { experianVerificationPrompt } from '@/Layouts/experianVerificationPrompt';
    import { proUpgradeNav } from '@/Layouts/proUpgradeNav';
    import RiskGuardProUpsellModal from '@/Components/RiskGuardProUpsellModal.vue';
    import SubscriptionProtection from '@/Shared/V2/SubscriptionProtection.vue';
    import axios from 'axios';

    const props = defineProps({
        title: String,
    })

    const currentYear =  moment().year()

    const agentMenu = ref([
        {
            id: 0,
            name: 'Home',
            href: 'home',
            icon: faFlag,
            active: isHomeNavActive(route().current()),
            role: 'agent',
            children: []
        },
        {
            id: 1,
            name: 'Properties',
            href: 'properties.index',
            icon: faHouseBuilding,
            active: route().current('properties.*'),
            role: 'agent',
            children: []
        },
        { id: 5, children: [], name: 'Resources', href: 'resources.index', icon: faQuestionCircle, role: 'agent', dropdown: true,
            children: [
                { id: 51, name: 'How to *', href: 'resources.index', icon: faQuestionCircle, active: (route().current('resources.*') && !route().current('blogs.*')) , role: 'agent' },
                { id: 52, name: 'Write a Blog Post', href: 'blogs.index', icon: faBlog, active: route().current('blogs.*'), role: 'agent' },
            ]
        },
    ])

    const page = usePage();

    // Bridge nav stays highlighted across the whole staff-tools area, not just
    // bridge.* names — the linked tools span several route-name prefixes.
    // Touch page.url so this recomputes on every Inertia navigation.
    const bridgeActive = computed(() => {
        page.url;
        return [
            'bridge.*',
            'email-logs.*',
            'impersonation.*',
            'impersonate',
            'reference-email-stats.*',
            'reports.partner-report',
        ].some((pattern) => route().current(pattern));
    });

    // Applicant menu: Self Reporting + Rental Applications + My Property (Rent Payments, Maintenance, Renter's Insurance, VA Loan are tabs under My Property)
    const applicantMenu = computed(() => {
        const items = [
            { id: 1, name: 'Self Reporting', href: 'reports.self-credit-check', icon: faCreditCard, active: ['reports.self-credit-check', 'reports.dashboard', 'reports.billing', 'reports.terms-and-conditions', 'reports.credit-report'].includes(route().current()), role: 'everyone' },
            { id: 2, name: 'Rental Applications', href: 'applicant.dashboard', icon: faScreenUsers, active: ['applicant.dashboard', 'application.steps', 'application.personal-information', 'application.financial-documents', 'application.credit-report', 'application.share'].includes(route().current()), role: 'everyone' },
        ];
        if (page.props.user && page.props.user.role === 'applicant' && page.props.has_my_property) {
            items.push({ id: 3, name: 'My Property', href: 'my-property', icon: faHouseBuilding, active: route().current('my-property'), role: 'everyone' });
        }
        return items;
    });

    // 86bc8j9ur: replaces the yellow verify banner that used to sit above every page.
    const experianPrompt = computed(() => experianVerificationPrompt(page.props.auth?.user));
    const proNav = computed(() => proUpgradeNav(page.props.auth?.user, route));

    // 86bc9e403: the top-bar "Upgrade to Pro" pill opens the combined checkout in place.
    const showProUpgradeModal = ref(false);
    const isProUpgrading = ref(false);
    const proTierChangedNotice = ref(null);
    const proStripeData = ref(null);
    const proSubscription = ref(null);
    // The agent's card and terms status aren't in the shared auth.user payload, so they come
    // from the card-setup-data fetch below — an agent who already has a card then sees it (and a
    // Change option) rather than being asked for a second card.
    const proUserPaymentMethod = ref(null);
    const proTermsAccepted = ref(false);

    const openProUpgrade = async () => {
        proTierChangedNotice.value = null;

        // Fetch the SetupIntent + the agent's card/terms status on demand the first time the
        // pop-up opens (nothing is created on a page load nobody acts on).
        if (!proStripeData.value) {
            try {
                const { data } = await axios.get(route('protect-subscription.card-setup-data'));
                proStripeData.value = data;
                proUserPaymentMethod.value = data.payment_method ?? null;
                proTermsAccepted.value = Boolean(data.terms_accepted);
            } catch {
                // Fall back to the pricing page if the SetupIntent can't be created.
                router.visit(route('pricing', { upgrade: 1 }));
                return;
            }
        }

        showProUpgradeModal.value = true;
    };

    const closeProUpgradeModal = () => {
        showProUpgradeModal.value = false;
        proTierChangedNotice.value = null;
        isProUpgrading.value = false;
    };

    const onProSubscribeStart = () => {
        isProUpgrading.value = true;
    };

    // 86bc9e403 #3: the card is on file now, but proUserPaymentMethod is a cached ref the
    // card-setup-data fetch set once. Update it so the still-open pop-up (and any reopen after a
    // later subscribe failure) shows the saved card + "Change", not a now-consumed SetupIntent.
    const onProCardSaved = (paymentMethod) => {
        if (paymentMethod) {
            proUserPaymentMethod.value = paymentMethod;
        }
    };

    const onProSubscribeSuccess = () => {
        // SubscriptionProtection already reloaded the page in place; just close the pop-up.
        showProUpgradeModal.value = false;
        isProUpgrading.value = false;
    };

    // 86bc9e403 #1: a declined card / failed subscribe clears processing (so the pop-up's
    // Subscribe button re-enables) and shows the reason inside the still-open pop-up.
    const onProSubscribeError = ({ error } = {}) => {
        isProUpgrading.value = false;
        // 86bc9e403 #D: by the time an attempt fails the terms were already accepted and saved
        // this attempt. proTermsAccepted comes from the one-time card-setup-data fetch and is
        // otherwise never refreshed, so a retry would re-show the Terms step. Flip it so the
        // retry skips it. (We only flip post-attempt, never before, so the FIRST attempt still
        // records acceptance — the new-card path relies on sending terms_accepted on it.)
        proTermsAccepted.value = true;
        proTierChangedNotice.value = error || 'We could not start your subscription. Please try again.';
    };

    // The price moved since the pop-up (a property was added meanwhile); nothing was charged.
    const onProTierChanged = ({ message } = {}) => {
        isProUpgrading.value = false;
        // 86bc9e403 #D: the terms were already saved on this attempt (the 409 came after); a
        // retry at the new price must not re-prompt for them.
        proTermsAccepted.value = true;
        router.reload({
            only: ['auth'],
            onSuccess: () => {
                proTierChangedNotice.value = message || null;
                showProUpgradeModal.value = true;
            },
        });
    };

    const progress = computed(() => {
        const user = page.props.user;
        if (!user?.completed_steps?.length || !user?.required_steps?.length) {
            return 0;
        }
        return (user.completed_steps.length / user.required_steps.length) * 100;
    });

    // Determine which menu to show based on user role. The partner program moved
    // out of the sidebar into the profile dropdown as "Passive Income" (RAC-10450),
    // so there is nothing left to filter by subscription here.
  const filteredMenu = computed(() => {
    return page.props.user.role === "agent" ? agentMenu.value : applicantMenu.value;
  });

  // Track which dropdown is open
  const activeDropdown = ref(null)
const activeSubDropdowns = reactive({})

// Toggle top-level dropdown like accordion
const toggleDropdown = (id) => {
  activeDropdown.value = activeDropdown.value === id ? null : id
  activeSubDropdowns[id] = null // close all sub-dropdowns when switching
}

const isDropdownOpen = (id) => activeDropdown.value === id

// Toggle second-level dropdown like accordion (per parent)
const toggleSubDropdown = (parentId, id) => {
  activeSubDropdowns[parentId] =
    activeSubDropdowns[parentId] === id ? null : id
}

const isSubDropdownOpen = (parentId, id) => {
  return activeSubDropdowns[parentId] === id
}

// Handle active state on page load
onMounted(() => {
  const openParents = (items, parentId = null) => {
    for (const item of items) {
      if (item.active) {
        if (parentId) activeSubDropdowns[parentId] = item.id
        return item.id
      }
      if (item.children && item.children.length > 0) {
        const found = openParents(item.children, item.id)
        if (found) {
          if (!parentId) activeDropdown.value = item.id
          else activeSubDropdowns[parentId] = item.id
          return true
        }
      }
    }
    return false
  }

  openParents(filteredMenu.value)
})

// Flyout menu functions for collapsed sidebar
const showFlyout = (event, itemId) => {
  const flyout = document.querySelector(`[data-flyout-id="${itemId}"]`)
  if (flyout) {
    // Calculate position relative to the trigger element in viewport
    const triggerRect = event.currentTarget.getBoundingClientRect()
    const sidebarWidth = 64 // Collapsed sidebar is always 64px (16 * 4)
    
    // Position relative to viewport since flyout is now at body level
    flyout.style.left = `${sidebarWidth}px` // sidebar width
    flyout.style.top = `${triggerRect.top}px` // account for scroll
    flyout.style.visibility = 'visible'
    flyout.style.opacity = '1'
    flyout.classList.remove('invisible')
    flyout.classList.remove('opacity-0')
  }
}

const hideFlyout = (event, itemId) => {
  // Add a small delay to prevent flickering when moving to flyout
  setTimeout(() => {
    const flyout = document.querySelector(`[data-flyout-id="${itemId}"]`)
    if (flyout && !flyout.matches(':hover')) {
      // Check if the trigger element still exists and is being hovered
      const isHoveringTrigger = event.currentTarget && event.currentTarget.matches && event.currentTarget.matches(':hover')
      if (!isHoveringTrigger) {
        flyout.style.visibility = 'invisible'
        flyout.style.opacity = '0'
        flyout.classList.add('invisible')
        flyout.classList.add('opacity-0')
      }
    }
  }, 100)
}

const keepFlyoutOpen = (event, itemId) => {
  const flyout = document.querySelector(`[data-flyout-id="${itemId}"]`)
  if (flyout) {
    flyout.style.visibility = 'visible'
    flyout.style.opacity = '1'
  }
}

// Nested flyout functions
const showNestedFlyout = (event, parentId, itemId) => {
  const flyout = document.querySelector(`[data-nested-flyout-id="${parentId}-${itemId}"]`)
  if (flyout) {
    flyout.style.visibility = 'visible'
    flyout.style.opacity = '1'
  }
}

const hideNestedFlyout = (event, parentId, itemId) => {
  setTimeout(() => {
    const flyout = document.querySelector(`[data-nested-flyout-id="${parentId}-${itemId}"]`)
    if (flyout && !flyout.matches(':hover')) {
      // Check if the trigger element still exists and is being hovered
      const isHoveringTrigger = event.currentTarget && event.currentTarget.matches && event.currentTarget.matches(':hover')
      if (!isHoveringTrigger) {
        flyout.style.visibility = 'invisible'
        flyout.style.opacity = '0'
      }
    }
  }, 100)
}

const keepNestedFlyoutOpen = (event, parentId, itemId) => {
  const flyout = document.querySelector(`[data-nested-flyout-id="${parentId}-${itemId}"]`)
  if (flyout) {
    flyout.style.visibility = 'visible'
    flyout.style.opacity = '1'
  }
}
  // Function to assign Tailwind rounded classes based on position
const childClass = (children, index) => {
//   if (index === 0) return "rounded-t-md";
  if (index === children.length - 1) return "rounded-b-md";
  return "";
};

const experianInfoPopup = ref(false);
const showExperianInfoPopup = () => {
    experianInfoPopup.value = true;
}

const is_show_blog_popup = ref(page.props.is_blog_popup);

// Impersonation
const stoppingImpersonation = ref(false);

const stopImpersonation = () => {
    if (stoppingImpersonation.value) return;

    stoppingImpersonation.value = true;

    router.post(route('impersonate.leave'), {}, {
        onFinish: () => {
            stoppingImpersonation.value = false;
        },
        onError: (errors) => {
            stoppingImpersonation.value = false;
            console.error('Stop impersonation error:', errors);
        }
    });
};

</script>
